import { toId } from './util/dataStreamId';
export const dataStreamFromSiteWise = ({ dataPoints = [], resolution = 0, aggregationType, ...propertyInfo }) => {
    return {
        id: toId(propertyInfo),
        aggregationType,
        data: dataPoints,
        resolution,
    };
};
